export default __webpack_public_path__ + "static/media/fad-digital0.9d866f23.svg";